var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M5.8335 11.7413V14.8333C5.8335 15.0493 5.97216 15.2407 6.17749 15.3087C6.22883 15.3253 6.28149 15.3333 6.33349 15.3333C6.48949 15.3333 6.64016 15.26 6.73616 15.1293L8.54482 12.668L5.8335 11.7413Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M15.79 0.0926647C15.6367 -0.016002 15.4354 -0.0306686 15.2687 0.0566647L0.268696 7.89C0.091363 7.98267 -0.0133037 8.172 0.00136299 8.37133C0.0166963 8.57133 0.149363 8.742 0.33803 8.80667L4.50803 10.232L13.3887 2.63866L6.5167 10.918L13.5054 13.3067C13.5574 13.324 13.612 13.3333 13.6667 13.3333C13.7574 13.3333 13.8474 13.3087 13.9267 13.2607C14.0534 13.1833 14.1394 13.0533 14.1614 12.9073L15.9947 0.573998C16.022 0.387331 15.9434 0.201998 15.79 0.0926647Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.4ea127764d1d377f567efbab099b52cb.svg";
export { ForwardRef as ReactComponent };